import {AnnouncementContainerFragment} from '../../../graphql/generated/types';
import {HelpItem} from '../type';

export function getHelpData(data: AnnouncementContainerFragment): HelpItem[] {
  return data.items.map(item => ({
    id: item.id,
    title: item.title,
    contents: item.contents,
  }));
}
